const MARKETPLACE_SOURCE = "MARKETPLACE";
const MANUAL_LIKE_SOURCES = new Set(["MANUAL", "IMPORT"]);

export const isMarketplaceTransaction = (source?: string | null): boolean =>
  String(source ?? "")
    .trim()
    .toUpperCase() === MARKETPLACE_SOURCE;

export const isManualLikeSource = (source?: string | null): boolean => {
  const normalized = String(source ?? "")
    .trim()
    .toUpperCase();

  return !normalized || MANUAL_LIKE_SOURCES.has(normalized);
};
